import { Navigate } from "react-router-dom";
import { getToken, getUserId } from "./auth";
import Login from "../Pages/Login";
import Register from "../Pages/Register";
import ForgetPassword from "../Pages/ForgetPassword";
import ResetPassword from "../Pages/ResetPassword";
import DashboardLayout from "./DashboardLayout";
import LoginLayout from "./LoginLayout";
import ObserverLayout from "./ObserverLayout";
import TeacherLayout from "./TeacherLayout";
import AdminDashboard from "../Pages/Admin/AdminDashboard";
import ObserverDashboard from "../Pages/Observer/ObserverDashboard";
import TeacherDashboard from "../Pages/Teachers/TeacherDashboard";
import Users from "../Pages/Admin/Users";
import NotFound404 from "../Components/NotFound404";
import CoScholasticPage from "../Pages/Forms/CoScholasticPage";
import CoScholasticDetails from "../Pages/Forms/FormInside/CoScholasticDetails";
import TeacherCoScholastic from "../Pages/Forms/FormInside/TeacherCoScholastic";
import CoScholasticReport from "../Pages/Reports/CoScholasticReport";

import UnderConstraction from "../Components/UnderConstraction";
import UserDetails from "../Pages/Admin/UserDetails";
import UserProfile from "../Pages/UserProfile";
import FortnightlyMonitor from "../Pages/Forms/FortnightlyMonitor";
import BasicDetailsForm from "../Components/BasicDeatilsForm";
import Details from "../Pages/Forms/FormInside/Details";
import ClassroomWalkthrough from "../Pages/Forms/ClassroomWalkthrough";
import DetailsWalkthrough from "../Pages/Forms/FormInside/DetailsWalkthrough";
import Notebook from "../Pages/Forms/Notebook";
import NoteBookDetails from "../Pages/Forms/FormInside/NoteBookDetails";
import TeacherWalkthrough from "../Pages/Forms/FormInside/TeacherWalkthrough";
import ObserverNotebook from "../Pages/Forms/FormInside/ObserverNotebook";
import Reader from "../Pages/Reports/Reader";
import FinalReport from "../Pages/Observer/FinalFom/FinalReport";
import WingCoordinator from "../Pages/Forms/WingCoordinator";
import ClassroomWalkthroughReader from "../Pages/Reports/ClassroomWalkthroughReader";
import FortnightlyMonitorInitiation from "../Pages/Observer/FinalFom/FortnightlyMonitorInitiation";
import InitiateBasicDetails from "../Components/InitiateBasicDetails";
import FortnightlyMonitorEdit from "../Pages/Teachers/FortnightlyMonitorEdit";
import OB_FortnightlyMonitorEdit from "../Pages/Observer/OB_FortnightlyMonitorEdit";
import OB_WalkthroughEdit from "../Pages/Observer/OB_WalkthroughEdit";
import OB_Notebook from "../Pages/Observer/OB_Notebook";
import TC_Notebook from "../Pages/Teachers/TC_Notebook";
import NotebookPDF from "../Pages/Reports/NotebookPDF";
import ClassSectionPage from "../Pages/Admin/ClassSectionPage";
import Weely4Page from "../Pages/Observer/Weely4Page";
import Weely4Form from "../Pages/Forms/Weely4Form";
import NoteBookInisiate from "../Pages/Observer/NoteBookInisiate";
import Weekly4FormReport from "../Pages/Reports/Weekly4FormReport";
import Fortnightly from "../Pages/Admin/Fortnightly";
import ClassRoom from "../Pages/Admin/ClassRoom";
import NoteBook from "../Pages/Admin/NootBook";
import Weekly from "../Pages/Admin/Weekly";
import NotebookComplete from "../Pages/Teachers/NotebookComplete";
import TextBox from "../Pages/TextBox";
import AdminReport from "../Pages/Admin/AdminReport";
import ObserverReports from "../Pages/Observer/ObserverReports";
import OB_Wing from "../Pages/Observer/Form/wing-coordinator/OB_Wing";
import WingCoordinatorReport from "../Pages/Reports/WingCoordinatorReport";
import AccountabilityMechanism from "../Pages/Forms/AccountabilityMechanism";
import AccountabilityForm from "../Pages/Forms/AccountabilityForm/AccountabilityForm";
import AccountabilityReport from "../Pages/Reports/AccountabilityReport";
import AuditLogs from "../Pages/Admin/AuditLogs";

const role = getUserId()?.access;
const isLoggedIn = getToken() !== null ? getToken() : null;
const getLoginRedirect = () => {
  if (
    typeof window !== "undefined" &&
    window.location.pathname &&
    window.location.pathname !== "/"
  ) {
    return `/login?redirect=${encodeURIComponent(
      window.location.pathname + window.location.search
    )}`;
  }
  return "/login";
};

const protects = {
  Teacher: [
    {
      path: "/",
      element:
        isLoggedIn && role === "Teacher" ? (
          <TeacherLayout />
        ) : (
          <Navigate to={getLoginRedirect()} replace />
        ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "/dashboard", element: <TeacherDashboard /> },
        { path: "/profile", element: <UserProfile /> },
        { path: "/fortnightly-monitor", element: <FortnightlyMonitor /> },
        { path: "/fortnightly-monitor/create", element: <BasicDetailsForm /> },
        { path: "/fortnightly-monitor/create/:id", element: <Details /> },
        {
          path: "/fortnightly-monitor/initiate/create/:id",
          element: <Details />,
        },
        { path: "/fortnightly-monitor/report/:id", element: <Reader /> },
        { path: "/classroom-walkthrough", element: <ClassroomWalkthrough /> },
        {
          path: "/classroom-walkthrough/create/:id",
          element: <TeacherWalkthrough />,
        },
        {
          path: "/classroom-walkthrough/report/:id",
          element: <ClassroomWalkthroughReader />,
        },
        { path: "/co-scholastic", element: <CoScholasticPage /> },
        { path: "/co-scholastic/create/:id", element: <TeacherCoScholastic /> },
        { path: "/co-scholastic/report/:id", element: <CoScholasticReport /> },
        { path: "/notebook-checking-proforma", element: <Notebook /> },
        {
          path: "/notebook-checking-proforma/create",
          element: <NoteBookDetails />,
        },
        {
          path: "/notebook-checking-proforma/create/:id",
          element: <TC_Notebook />,
        },
        {
          path: "/notebook-checking-proforma/initiate/create/:id",
          element: <TC_Notebook />,
        },
        {
          path: "/fortnightly-monitor/edit/:id",
          element: <FortnightlyMonitorEdit />,
        },
        // {path:"/classroom-walkthrough/edit/:id",element:<OB_WalkthroughEdit/>},
        {
          path: "/notebook-checking-proforma/edit/:id",
          element: <TC_Notebook />,
        },
        {
          path: "/notebook-checking-proforma/report/:id",
          element: <NotebookPDF />,
        },
        { path: "/weekly4form", element: <Weely4Page /> },
        { path: "/weekly4form/create", element: <Weely4Form /> },
        { path: "/weekly4form/create/:id", element: <Weely4Form /> },
        { path: "/weekly4form/report/:id", element: <Weekly4FormReport /> },
        {
          path: "/notebook-checking-proforma/complete/:id",
          element: <NotebookComplete />,
        },
        { path: "*", element: <NotFound404 /> },
      ],
    },
  ],
  Superadmin: [
    {
      path: "/",
      element:
        isLoggedIn && role === "Superadmin" ? (
          <DashboardLayout />
        ) : (
          <Navigate to={getLoginRedirect()} replace />
        ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "/dashboard", element: <AdminDashboard /> },
        { path: "/users", element: <Users /> },
        { path: "/users/:id", element: <UserDetails /> },
        { path: "/reports", element: <Navigate to="/reports/fortnightly-monitor" replace /> },
        { path: "/reports/fortnightly-monitor", element: <AdminReport /> },
        { path: "/reports/classroom-walkthrough", element: <AdminReport /> },
        { path: "/reports/notebook-checking-proforma", element: <AdminReport /> },
        { path: "/reports/weekly4form", element: <AdminReport /> },
        { path: "/reports/wing-coordinator", element: <AdminReport /> },
        { path: "/reports/accountability", element: <AdminReport /> },
        { path: "/reports/co-scholastic", element: <AdminReport /> },
        { path: "/co-scholastic", element: <CoScholasticPage /> },
        { path: "/co-scholastic/report/:id", element: <CoScholasticReport /> },

        { path: "/profile", element: <UserProfile /> },
        { path: "/fortnightly-monitor", element: <Fortnightly /> },
        { path: "/fortnightly-monitor/report/:id", element: <Reader /> },
        { path: "/classroom-walkthrough", element: <ClassRoom /> },
        {
          path: "/classroom-walkthrough/report/:id",
          element: <ClassroomWalkthroughReader />,
        },
        { path: "/notebook-checking-proforma", element: <NoteBook /> },
        {
          path: "/notebook-checking-proforma/create",
          element: <NoteBookDetails />,
        },
        {
          path: "/notebook-checking-proforma/create/:id",
          element: <ObserverNotebook />,
        },
        {
          path: "/notebook-checking-proforma/initiate/create/:id",
          element: <ObserverNotebook />,
        },
        {
          path: "/notebook-checking-proforma/edit/:id",
          element: <OB_Notebook />,
        },
        {
          path: "/notebook-checking-proforma/complete/:id",
          element: <NotebookComplete />,
        },
        {
          path: "/notebook-checking-proforma/report/:id",
          element: <NotebookPDF />,
        },
        {
          path: "/classroom-walkthrough/create",
          element: <DetailsWalkthrough />,
        },
        {
          path: "/classroom-walkthrough/create/:id",
          element: <DetailsWalkthrough />,
        },
        {
          path: "/classroom-walkthrough/edit/:id",
          element: <OB_WalkthroughEdit />,
        },
        { path: "/co-scholastic/create", element: <CoScholasticDetails /> },
        { path: "/co-scholastic/create/:id", element: <CoScholasticDetails /> },
        { path: "/weekly4form/create", element: <Weely4Form /> },
        { path: "/weekly4form/create/:id", element: <Weely4Form /> },
        { path: "/weekly4form/edit/:id", element: <Weely4Form /> },
        { path: "/fortnightly-monitor/create", element: <BasicDetailsForm /> },
        { path: "/fortnightly-monitor/create/:id", element: <Details /> },
        { path: "/fortnightly-monitor/initiate/create/:id", element: <Details /> },
        { path: "/fortnightly-monitor/edit/:id", element: <OB_FortnightlyMonitorEdit /> },
        { path: "/weekly4form", element: <Weekly /> },
        { path: "/weekly4form/report/:id", element: <Weekly4FormReport /> },
        { path: "/wing-coordinator", element: <WingCoordinator /> },
        { path: "/accountability", element: <AccountabilityMechanism /> },
        { path: "/accountability/:id", element: <AccountabilityForm /> },
        { path: "/accountability/report/:id", element: <AccountabilityReport /> },
        { path: "/class-section", element: <ClassSectionPage /> },
        { path: "/audit-logs", element: <AuditLogs /> },
        { path: "*", element: <NotFound404 /> },
      ],
    },
  ],
  Observer: [
    {
      path: "/",
      element:
        isLoggedIn && role === "Observer" ? (
          <ObserverLayout />
        ) : (
          <Navigate to={getLoginRedirect()} replace />
        ),
      children: [
        { path: "/", element: <Navigate to="/dashboard" /> },
        { path: "/dashboard", element: <ObserverDashboard /> },
        { path: "/reports", element: <Navigate to="/reports/fortnightly-monitor" replace /> },
        { path: "/reports/fortnightly-monitor", element: <ObserverReports /> },
        { path: "/reports/classroom-walkthrough", element: <ObserverReports /> },
        { path: "/reports/notebook-checking-proforma", element: <ObserverReports /> },
        { path: "/reports/weekly4form", element: <ObserverReports /> },
        { path: "/reports/wing-coordinator", element: <ObserverReports /> },
        { path: "/reports/accountability", element: <ObserverReports /> },
        { path: "/reports/co-scholastic", element: <ObserverReports /> },
        { path: "/co-scholastic", element: <CoScholasticPage /> },
        { path: "/co-scholastic/create", element: <CoScholasticDetails /> },
        { path: "/co-scholastic/create/:id", element: <CoScholasticDetails /> },
        { path: "/co-scholastic/report/:id", element: <CoScholasticReport /> },

        { path: "/fortnightly-monitor", element: <FortnightlyMonitor /> },
        { path: "/profile", element: <UserProfile /> },
        { path: "/fortnightly-monitor", element: <FortnightlyMonitor /> },
        { path: "/fortnightly-monitor/create", element: <BasicDetailsForm /> },
        {
          path: "/fortnightly-monitor/initiate/create/:id",
          element: <Details />,
        },
        { path: "/fortnightly-monitor/create/:id", element: <Details /> },
        { path: "/fortnightly-monitor/report/:id", element: <Reader /> },
        { path: "/classroom-walkthrough", element: <ClassroomWalkthrough /> },
        {
          path: "/classroom-walkthrough/create",
          element: <DetailsWalkthrough />,
        },
        {
          path: "/classroom-walkthrough/create/:id",
          element: <DetailsWalkthrough />,
        },
        {
          path: "/classroom-walkthrough/report/:id",
          element: <ClassroomWalkthroughReader />,
        },
        { path: "/notebook-checking-proforma", element: <Notebook /> },
        {
          path: "/notebook-checking-proforma/create",
          element: <NoteBookDetails />,
        },
        {
          path: "/notebook-checking-proforma/create/:id",
          element: <ObserverNotebook />,
        },
        {
          path: "/notebook-checking-proforma/initiate/create/:id",
          element: <ObserverNotebook />,
        },
        {
          path: "/fortnightly-monitor/form-initiation",
          element: <FortnightlyMonitorInitiation />,
        },
        {
          path: "/fortnightly-monitor/edit/:id",
          element: <FortnightlyMonitorEdit />,
        },
        {
          path: "/classroom-walkthrough/edit/:id",
          element: <OB_WalkthroughEdit />,
        },
        {
          path: "/notebook-checking-proforma/edit/:id",
          element: <OB_Notebook />,
        },
        {
          path: "/notebook-checking-proforma/form-initiation",
          element: <NoteBookInisiate />,
        },
        {
          path: "/notebook-checking-proforma/report/:id",
          element: <NotebookPDF />,
        },
        {
          path: "/notebook-checking-proforma/complete/:id",
          element: <NotebookComplete />,
        },
        { path: "/weekly4form", element: <Weely4Page /> },
        { path: "/weekly4form/create", element: <Weely4Form /> },
        { path: "/weekly4form/edit/:id", element: <Weely4Form /> },
        { path: "/weekly4form/report/:id", element: <Weekly4FormReport /> },
        { path: "/wing-coordinator", element: <WingCoordinator /> },
        { path: "/wing-coordinator/:id", element: <OB_Wing /> },
        { path: "/wing-coordinator/report/:id", element: <WingCoordinatorReport /> },
        { path: "/accountability", element: <AccountabilityMechanism /> },
        { path: "/accountability/:id", element: <AccountabilityForm /> },
        { path: "/accountability/report/:id", element: <AccountabilityReport /> },
        { path: "*", element: <NotFound404 /> },
      ],
    },
  ],
  default: [
    {
      path: "/",
      element: !isLoggedIn ? <LoginLayout /> : <Navigate to="/dashboard" />,
      children: [
        { path: "/", element: <Login /> },
        { path: "/login", element: <Login /> },
        { path: "/signup", element: <Register /> },
        { path: "/forget-password", element: <ForgetPassword /> },
        { path: "/reset-password/:token", element: <ResetPassword /> },
        { path: "/test", element: <TextBox /> },
        {
          path: "*",
          element: (
            <Navigate
              to={
                typeof window !== "undefined" &&
                window.location.pathname &&
                window.location.pathname !== "/"
                  ? `/login?redirect=${encodeURIComponent(
                      window.location.pathname + window.location.search
                    )}`
                  : "/login"
              }
              replace
            />
          ),
        },
      ],
    },
  ],
};

export const protect =
  role && isLoggedIn ? protects[role] : protects["default"];
export const defaultProtect = protects["default"];
